import { useState, useEffect } from "react";
import SuccessIcon from "../constants/assests/image/SuccessIcon.png";
import InputFiled from "../shared/inputFiled";
import PasswordFiled from "../shared/passwordFiled";
import FillButton from "../shared/fillButton";
import { useSelector, useDispatch } from "react-redux";
import { loginUser, clearMessages } from "../models/authSlice";
import { RootState, AppDispatch } from "../reduxStore/store";
import { useNavigate } from "react-router-dom";
import BuyCard from "./buyCard";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import useClipboard from "react-use-clipboard";
import { useLocation } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import the arrow icon
import LoadingIndicator from "../shared/loadingIndicator";
import Emptydata from "../shared/emptyData";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const PurchaseCoupon: React.FC = () => {
  const couponsCode = useSelector((state: RootState) => state.purchase.coupon?.coupon_code);
  const wholeLoading = useSelector((state: RootState) => state.purchase.loading);
  const loading = useSelector((state: RootState) => state.auth.loading);
  const error = useSelector((state: RootState) => state.auth.error);
  const successMessage = useSelector((state: RootState) => state.auth.successMessage);


  const [isCopied, setCopied] = useClipboard(couponsCode ?? '', { successDuration: 1000 });

  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(clearMessages());
    if (successMessage) {
      navigate("/homePage");
    }
  }, [successMessage, navigate, dispatch]);

  return (
    <div className="relative min-h-screen w-screen flex flex-col justify-center items-center overflow-x-hidden">
      {/* Arrow icon at the top left */}
      {wholeLoading ? (
        <LoadingIndicator />
      ) : (
        <>
      <div className="absolute top-4 left-4">
        <a href="/homePage"><KeyboardArrowLeftIcon 
          fontSize="medium"
          onClick={() => navigate(-1)} 
          className="cursor-pointer"
        /></a>
      </div>

      <div className="flex flex-col justify-center items-center text-center">
        <img src={SuccessIcon} width={100} height={100} alt="Login Logo" />
        <div className="mt-4">
          <p className="text-xl font-bold">Success</p>
          <p className="text-lg">You have successfully purchased a coupon</p>

          <Card
            sx={{
              maxWidth: 345,
              backgroundColor: "#aee5e8",
              padding: 2,
              textAlign: "center",
            }}
          >
            <Typography variant="subtitle1" color="textSecondary">
              Coupon Code
            </Typography>
            <Typography variant="h4" sx={{ marginY: 2 }}>
              {couponsCode}
            </Typography>
            <Button variant="contained" color="primary" onClick={setCopied}>
              {isCopied ? "Yes! 👍" : "Copy Code"}
            </Button>
          </Card>
        </div>
      </div>
      <div className="absolute bottom-4 w-full flex justify-center items-center">
        <a href="/mycoupons">
          <FillButton
            name="My Coupons"
            onClick={() => {
              console.log("hello");
            }}
            disabled={loading}
          />
        </a>
      </div>
      </>
      )}
    </div>
  );
};

export default PurchaseCoupon;
